export const sessionMessages = { expired: 'نشست شما پایان یافت؛ دوباره وارد شوید.' };
